import React, { Component } from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { Equipment, BaseEquipment } from 'fitbeat.models';
import { styles as SharedStyles, getResponsiveStyleSheet } from '../../Bookings/components/Styles';
import WorkoutSettingSection from '../../Bookings/components/WorkoutSettingSection';
import { BodyweightIcon, DumbbellsIcon, EquipmentIcon } from './Icons';
import Theme from '../../theme';
import { moderateScale } from 'react-native-size-matters';
import { defaultScale } from '../../utils/scaling';
const responsive = getResponsiveStyleSheet();

class EquipmentList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedEquipmentList: [],
            displayEquipment: [],
            icons: {
                Bodyweight: <BodyweightIcon color={Theme.BLACK} width={defaultScale(25)} height={defaultScale(25)} />,
                Dumbbells: <DumbbellsIcon color={Theme.BLACK} width={defaultScale(25)} height={defaultScale(25)} />,
                BasicCombo1: <EquipmentIcon color={Theme.BLACK} width={defaultScale(30)} height={defaultScale(20)} />
            }
        }
    }
    componentDidMount() {
        const { currentSelectedEquipment = [] } = this.props;
        this.getEquipmentList();
        const selectedEquipmentList = BaseEquipment.getAllForEquipment(currentSelectedEquipment);
        this.setState({ selectedEquipmentList })
    }


    getEquipmentList = () => {
        const { icons } = this.state;
        let availableEquipment = Object.keys(BaseEquipment.EquipmentDisplay).map((key) => {
            const { displayName, equipment } = BaseEquipment.EquipmentDisplay[key];
            let equipmentObj = {
                key,
                title: displayName,
                icon: icons[key],
                isDisabled: equipment.indexOf(Equipment.Bodyweight) >= 0 && equipment.length <= 1,
            }
            return equipmentObj;
        });
        this.setState({ displayEquipment: availableEquipment })
        return availableEquipment;
    }

    toggleEquipment = (equipmentKey) => {
        const { selectedEquipmentList } = this.state;
        let equipmentList = [...selectedEquipmentList];
        const selectedEquipment = BaseEquipment.EquipmentDisplay[equipmentKey];
        let index = equipmentList.indexOf(selectedEquipment);
        if (index === -1) {
            equipmentList = this.addBasicComboIfDumbbellsIsSelected(selectedEquipment, equipmentList);
            equipmentList.push(selectedEquipment);
        } else {
            equipmentList = this.removeBasicComboIfDumbbellsIsUnselected(selectedEquipment, equipmentList);
            index = equipmentList.indexOf(selectedEquipment);
            equipmentList.splice(index, 1);
        }
        this.setState({ selectedEquipmentList: equipmentList });
        const equipmentArray = equipmentList.map(({ equipment }) => equipment);
        const equipment = [].concat.apply([], equipmentArray);
        const equipmentSet = [...new Set(equipment)];
        this.props.onCompleteEquipmentChange(equipmentSet);
    }

    addBasicComboIfDumbbellsIsSelected = (selectedEquipmentKey, selectedEquipmentList) => {
        const basicCombo = BaseEquipment.EquipmentDisplay.BasicCombo1;
        const dumbbells = BaseEquipment.EquipmentDisplay.Dumbbells;
        if (selectedEquipmentKey.displayName === dumbbells.displayName) {
            if (selectedEquipmentList.indexOf(basicCombo) === -1) {
                selectedEquipmentList.push(basicCombo);
            }
        }
        return selectedEquipmentList;
    }

    removeBasicComboIfDumbbellsIsUnselected = (selectedEquipmentKey, selectedEquipmentList) => {
        const basicCombo = BaseEquipment.EquipmentDisplay.BasicCombo1;
        const dumbbells = BaseEquipment.EquipmentDisplay.Dumbbells;
        if (selectedEquipmentKey.displayName === basicCombo.displayName) {
            const basicIndex = selectedEquipmentList.indexOf(dumbbells);
            if (basicIndex !== -1) {
                selectedEquipmentList.splice(basicIndex, 1);
            }
        }
        return selectedEquipmentList;
    }

    renderSettingsSection = (singleEquipment, index) => {
        const { selectedEquipmentList } = this.state;
        const { firstContainerStyling = {} } = this.props;
        const { rowDisplay = true, noBorder = false } = this.props;
        containerBorder = rowDisplay && !noBorder ? styles.leftBorder : {}
        const workoutSettingsSection = (
            <WorkoutSettingSection
                disabled={singleEquipment.isDisabled}
                selector={'Checkbox'}
                isActiveSetting={selectedEquipmentList.findIndex(({ displayName }) => displayName === singleEquipment.title) >= 0}
                onPress={() => this.toggleEquipment(singleEquipment.key)}
                title={''}
                containerStyle={index === 0 ? firstContainerStyling : containerBorder}
                subtitleStylesOverride={[SharedStyles.settingsTitle, { fontSize: moderateScale(11, 0.5) }]}
                subtitle={singleEquipment.title}
                icon={singleEquipment.icon}
            />
        )
        if (index === 0) {
            return (
                <View style={responsive.leftSettingsContainer}>
                    {workoutSettingsSection}
                </View>
            )
        }

        return workoutSettingsSection;
    }

    render() {
        const { displayEquipment } = this.state;
        const { rowDisplay = true } = this.props;
        return (
            <View style={[{ flex: 1, flexDirection: rowDisplay ? 'row' : 'column' }]}>
                {displayEquipment.map((singleEquipment, index) => {
                    return this.renderSettingsSection(singleEquipment, index);
                })}
            </View>
        )
    }
}
const styles = StyleSheet.create({
    leftBorder: {
        borderLeftWidth: 1,
        borderLeftColor: '#d8d8d8',
        paddingLeft: defaultScale(10),
    },
});
export default EquipmentList;
